import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    wrapDialog: {
        width: 250, 
        padding: 20, 
        display: 'flex', 
        flexDirection: 'column',
        height: '100%'
    },
    titleDialog: {
        textAlign: 'center',
        margin: 0, 
        padding: 0, 
        marginBottom: 12
    },
    dialogButton: {
        padding: '5px 10px',
        maxHeight: '48px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        textTransform: 'uppercase',
        fontSize: 14,
        fontFamily: "PT Sans, sans-serif",
        userSelect: 'none',
        cursor: 'pointer',
        fontWeight: 700,
        textAlign: 'center',
        background: 'rgb(0, 231, 110)',
        color: 'rgb(36, 38, 62)',
        border: 'none',
        borderRadius: 4,
        marginRight: 12,
        width: 100,
    },
    wrap: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%'
    },
    textarea: {
        color: '#aeaeae',
        background: '#fff',
        border: '1px solid #e7e7e7',
        borderRadius: '4px',
        // boxShadow: '0 1px 0 0 hsl(0deg 0% 100% / 15%), inset 0 1px 0 0 rgb(0 0 0 / 15%)',
        padding: '6px',
        minWidth: '40px',
        width: '95%',
        height: '140px',
        resize: 'none',
        outline: 'none'
    },
    wrapDialogButton: {
        display: 'flex',
        justifyContent: 'center', 
        marginTop: 12
    }
}))

export {
    useStyles
}